export default "__VITE_ASSET__C$zqsD6d__"